import { useState } from 'react';
import { Dialog, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import WPDialog from '../../../components/Dialog';
import { i18n } from '../../../language';
import { Base } from './Base';

const useStyle = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-rounded': {
      marginTop: '-2.5rem',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.393rem 0.75rem rgba(0, 0, 0, 0.04)',
    },
  },
  dialogBody: {
    color: theme.palette.font.main,
    fontSize: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    lineHeight: '1.875rem',
  },
  dialogIcon: {
    fontSize: '1rem',
    color: '#5f9df6',
    float: 'right',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  btn: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
}));

const ExpiryLoginPop = ({ open, closeHandle, submitHandle }) => {
  const classes = useStyle();
  const [logoutWarnOpen, setLogoutWarnOpen] = useState(false);
  const warmLostInput = useSelector((state) => state.expiryLogin.warnLostMsg);

  const openLogoutWarn = () => {
    if (warmLostInput) {
      setLogoutWarnOpen(true);
    } else {
      closeHandle();
    }
  };

  return open ? (
    <div>
      <WPDialog
        id="ExpLogin-DiaLog-confirm-logout"
        open={logoutWarnOpen}
        title={i18n.t('DUTYASSIGN_NOT_SAVE_TITLE')}
        cancel={i18n.t('SETTING_CANCEL')}
        confirm={i18n.t('LOGIN_LOG_OUT')}
        handleCancel={() => setLogoutWarnOpen(false)}
        handleClose={() => setLogoutWarnOpen(false)}
        handleConfirm={() => {
          closeHandle();
        }}
      >
        <div className={classes.dialogBody}>{i18n.t('DUTYASSIGN_NOT_SAVE_BODY')}</div>
      </WPDialog>

      <Dialog open={open} className={classes.dialog}>
        <Base
          loginBtnDesc={i18n.t('EHANDOVER_LOGIN_BUTTON')}
          logoutBtnDesc={i18n.t('LOGIN_LOG_OUT')}
          submitClick={submitHandle}
          closeHandle={openLogoutWarn}
        />
      </Dialog>
    </div>
  ) : null;
};

export default ExpiryLoginPop;
